.hero {
  position: relative;
  min-height: calc(var(--hero-height) - var(--hero-padding));
  box-sizing: border-box;

  --hero-height: 90vh;
  --hero-padding: 0px;

  &.accent::after {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 20vh;
    bottom: 0;
    background-color: var(--hero-accent);
    clip-path: ellipse(50% 20% at 50% 100%);
  }
}
